const timeoutPeriodDefault = 60000;
const tintervalPeriodDefault = 100;

export function waitForNodes(options) {
  if (window.Promise !== undefined) {
    return usePromise(options);
  }
  options.PromiseFactory = FakePromise;
  return usePromise(options);
}

function usePromise(options) {
  const {
    PromiseFactory = Promise,
    selector,
    parentNode = document,
    timeoutPeriod = timeoutPeriodDefault,
    intervalPeriod = tintervalPeriodDefault
  } = options;
  return new PromiseFactory((resolve, reject) => {
    let timeout = null;
    let interval = null;
    interval = setInterval(() => {
      const nodes = parentNode.querySelectorAll(selector);
      if (nodes.length) {
        clearInterval(interval);
        clearTimeout(timeout);
        resolve(Array.prototype.slice.call(nodes));
      }
    }, intervalPeriod);
    timeout = setTimeout(() => {
      const error = new Error(
        `Selector '${selector}' was not found during ${timeoutPeriod /
          1000} seconds`
      );
      clearInterval(interval);
      reject(error);
    }, timeoutPeriod);
  });
}

function FakePromise(executor) {
  const noop = () => {};
  let resolve = noop;
  let reject = noop;

  this.pending = true;
  this.rejected = false;
  this.rejected = false;

  this.then = cb => {
    resolve = cb;
    if (this.fulfilled) {
      cb(this.result);
    }
    return this;
  };

  this.catch = cb => {
    reject = cb;
    if (this.rejected) {
      cb(this.error);
    }
    return this;
  };

  try {
    executor(
      result => {
        this.result = result;
        this.fulfilled = true;
        resolve(result);
      },
      error => {
        this.error = error;
        this.rejected = true;
        reject(error);
      }
    );
  } catch (e) {
    if (reject !== noop) {
      reject(e);
    } else {
      throw e;
    }
  }
}
